import React, { useState, useEffect } from 'react';
import { TopBarStationContext, type TopBarStationId } from './topBarStationTypes';

const STORAGE_KEY = 'top-bar-station-id';

const VALID_IDS: TopBarStationId[] = ['1', '2', '3', '4', 'avg'];

function parseStored(stored: string | null): TopBarStationId {
  if (stored && VALID_IDS.includes(stored as TopBarStationId)) {
    return stored as TopBarStationId;
  }
  return 'avg'; // default: average of all stations
}

export const TopBarStationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [topBarStationId, setTopBarStationIdState] = useState<TopBarStationId>(() => {
    return parseStored(localStorage.getItem(STORAGE_KEY));
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, topBarStationId);
  }, [topBarStationId]);

  const setTopBarStationId = React.useCallback((id: TopBarStationId) => {
    setTopBarStationIdState(id);
  }, []);

  return (
    <TopBarStationContext.Provider value={{ topBarStationId, setTopBarStationId }}>
      {children}
    </TopBarStationContext.Provider>
  );
};
